<template>
  <div class="weblist_wrap">
    <div v class="top_wrap">
      <div class="tools_wrap">
        <vxe-button
          class="my_btn"
          v-for="(item, index) in tableConfig.buttonList"
          :key="index"
          status="primary"
          size="mini"
          v-if="(tableConfig.noRole ? true : formatBtn(item.id)) && item.name"
          :content="tableConfig.noRole ? item.name : buttonObj[formatBtn(item.id)]"
          :disabled="loading"
          @click="btnClickHandle(item)"
        ></vxe-button>
        <div class="slot_wrap">
          <div class="query_wrap" v-if="tableConfig.queryConfig && JSON.stringify(tableConfig.queryConfig) != '{}'">
            <div class="showMore" @click="toggleQuery" v-if="originQueryHidden.length">
              <i class="el-icon-arrow-down" v-if="!toggleQueryStatus"></i>
              <i class="el-icon-arrow-up" v-if="toggleQueryStatus"></i>
            </div>
            <div
              class="query_item"
              v-if="item.label && item.kjlx && index != 'undefined' && !item.hidden"
              v-for="(item, index) in tableConfig.queryConfig"
              :class="item.width || 'w_33'"
              :key="index"
            >
              <div class="lab" :style="{ flex: '0 0 ' + (tableConfig.queryLabelWidth ? tableConfig.queryLabelWidth : 90) + 'px' }">
                {{ item.label }}：
              </div>
              <div class="con">
                <vxe-input
                  v-if="item.kjlx == 'input'"
                  class="my_inp"
                  v-model="item.value"
                  :placeholder="'请输入' + item.label"
                  size="small"
                ></vxe-input>
                <vxe-radio-group v-if="item.kjlx == 'radio'" v-model="item.value">
                  <vxe-radio v-for="(item2, index2) in item.list" :key="index2" :label="item2.value" :content="item2.label"></vxe-radio>
                </vxe-radio-group>
                <vxe-select
                  v-if="item.kjlx == 'select'"
                  v-model="item.value"
                  :placeholder="'请输入' + item.label"
                  @change="changeQuery(item)"
                  size="mini"
                  class="my_inp"
                >
                  <vxe-option v-for="(item2, index2) in item.list" :value="item2.value" :label="item2.label"></vxe-option>
                </vxe-select>
                <el-date-picker
                  v-if="item.kjlx == 'date'"
                  v-model="item.value"
                  :placeholder="'请选择' + item.label"
                  value-format="yyyy-MM-dd"
                  class="my_inp"
                  size="mini"
                  type="date"
                ></el-date-picker>
                <el-date-picker
                  v-if="item.kjlx == 'daterange'"
                  v-model="item.rangeValue"
                  :placeholder="'请选择' + item.label"
                  value-format="yyyy-MM-dd"
                  class="my_inp"
                  size="mini"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  type="daterange"
                  @change="changeRange($event, item)"
                ></el-date-picker>
                <el-date-picker
                  v-if="item.kjlx == 'datetime'"
                  v-model="item.value"
                  :placeholder="'请选择' + item.label"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  class="my_inp"
                  size="mini"
                  type="datetime"
                ></el-date-picker>
                <el-date-picker
                  v-if="item.kjlx == 'datetimerange'"
                  v-model="item.rangeValue"
                  :placeholder="'请选择' + item.label"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  class="my_inp"
                  size="mini"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  type="datetimerange"
                  @change="changeRange($event, item)"
                ></el-date-picker>
              </div>
            </div>
            <div class="query_btn_wrap" :class="tableConfig.queryBtnWidth || 'w_33'">
              <div class="query_btn">
                <vxe-button class="my_btn" status="primary" size="mini" @click="resetQuery">重置</vxe-button>
                <vxe-button class="my_btn" status="primary" size="mini" @click="query">搜索</vxe-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table_wrap">
        <vxe-table
          class="my_table"
          ref="my_table"
          :key="tableKey"
          :data="rows"
          border
          show-header-overflow
          show-overflow
          highlight-hover-row
          height="auto"
          auto-resize
          stripe
          round
          resizable
          :loading="loading"
          :checkbox-config="checkboxConfig"
          :radio-config="radioConfig"
          header-row-class-name="my_head"
          :show-footer="JSON.stringify(footer) != '{}'"
          @cell-dblclick="dblRowHandle"
        >
          <vxe-table-column width="50" v-if="!tableConfig.singleselect" type="checkbox" field="my_check" align="center"></vxe-table-column>
          <vxe-table-column width="50" v-if="tableConfig.singleselect" type="radio" field="my_check" align="center"></vxe-table-column>
          <vxe-table-column align="center" type="seq" title="序号" width="60" field="index"></vxe-table-column>
          <vxe-table-column
            v-if="!item.hidden"
            v-for="(item, index) in tableConfig.listConfig"
            :key="index"
            :field="item.zdname"
            :title="item.label"
            :align="tableConfig.align ? tableConfig.align : 'center'"
            :width="item.width || null"
            :sortable="!item.tableButtonList"
            :fixed="item.fixed"
          >
            <template #default="{ row ,rowIndex }">
              <div v-if="item.formatFunc">
                <div v-html="formatFunc(row, item.zdname, item.formatFunc)"></div>
              </div>
              <div v-if="!item.formatFunc">
                <div v-if="!item.format">{{ row[item.zdname] }}</div>
                <div v-if="item.format">{{ item.format(row[item.zdname]) }}</div>
              </div>
              <div v-if="item.tableButtonList">
                <el-button
                  class="my_btn"
                  v-for="(item2, index2) in item.tableButtonList"
                  :key="index2"
                  status="primary"
                  size="mini"
                  :content="item2.name"
                  type="primary"
                  plain
                  @click.stop="item2['func'](row)"
                  >{{ item2.name }}</el-button
                >
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <div class="footer_wrap">
      <vxe-pager
        perfect
        :current-page.sync="pageIndex"
        :page-size.sync="pageSize"
        :loading="loading"
        :total="total"
        :page-sizes="[20, 50, 100, 1000]"
        :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
        @page-change="pageChange"
      >
        <template #left>
          <vxe-button size="small" @click="getData">
            <template #default>
              <i :class="{ 'el-icon-refresh': !loading, 'el-icon-loading': loading }"></i>
            </template>
          </vxe-button>
        </template>
      </vxe-pager>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableConfig: {
      type: Object,
      required: true,
      default: {},
    },
  },
  name: "CommonWebList",

  data() {
    return {
      param: "",
      timeout: null,
      buttonList: [],
      zdzdList: [],
      footer: {},
      rows: [],
      total: 0,
      form: {},
      pageIndex: 1,
      pageSize: 20,
      filterRules: [
        { label: "等于", value: "equal" },
        { label: "包含", value: "contains" },
        { label: "不等于", value: "notequal" },
        { label: "匹配开头", value: "beginwith" },
        { label: "匹配结尾", value: "endwith" },
      ],
      singleselect: false,
      loading: false,
      tableKey: 1,
      checkboxConfig: {},
      radioConfig: {},
      originQueryValueObj: {},
      originQueryHidden: [],
      toggleQueryStatus: false,
    };
  },

  methods: {
    toggleQuery() {
      var q = this.tableConfig.queryConfig;
      for (var i in q) {
        if (!this.toggleQueryStatus) {
          this.$set(q[i], "hidden", false);
        } else {
          if (this.originQueryHidden.includes(i)) {
            this.$set(q[i], "hidden", true);
          } else {
            this.$set(q[i], "hidden", false);
          }
        }
      }
      this.toggleQueryStatus = !this.toggleQueryStatus;
    },
    changeRange(val, item) {
      if (val) {
        item.value = val.join("/");
      } else {
        item.value = "";
      }
    },
    pageChange({ type }) {
      if (type == "current") {
        this.getData();
      }
      if (type == "size") {
        this.pageIndex = 1;
        this.getData();
      }
    },
    changeQuery(item) {
      if (this.tableConfig.env == "iframe") {
        if (item.changeFunction && window[item.changeFunction]) {
          window[item.changeFunction](item.value);
        }
      } else {
        if (item.changeFunction && this.$parent[item.changeFunction]) {
          this.$parent[item.changeFunction](item.value);
        }
      }
    },
    btnClickHandle(item) {
      if (this.tableConfig.env == "iframe") {
        if (item.funcName && window[item.funcName]) {
          window[item.funcName](this.chosen());
        } else if (item.func) {
          item.func(this.chosen());
        }
      } else {
        if (item.funcName && this.$parent[item.funcName]) {
          this.$parent[item.funcName](this.chosen());
        } else if (item.func) {
          item.func(this.chosen());
        }
      }
    },
    resetQuery() {
      for (var i in this.tableConfig.queryConfig) {
        var l = this.tableConfig.queryConfig[i].list;
        if (l && l.length && !l.find((e) => !e.value)) {
          this.tableConfig.queryConfig[i].value = l[0].value;
        } else {
          this.tableConfig.queryConfig[i].value = this.originQueryValueObj[i];
        }
        this.tableConfig.queryConfig[i].rangeValue = [];
      }
      if (window["resetQuery"]) {
        window["resetQuery"]();
      }
      this.query();
    },
    query() {
      this.pageIndex = 1;
      this.getData();
    },
    formatFunc(row, value, func) {
      if (this.tableConfig.env == "iframe") {
        if (window[func]) {
          return window[func](row, value);
        } else {
          return "";
        }
      }
      if (this.tableConfig.env == "vue") {
        if (this.$parent[func]) {
          return this.$parent[func](row, value);
        } else {
          return "";
        }
      }
    },
    formatBtn(id) {
      if (!(id instanceof Array)) {
        id = [];
      }
      var arr = id.filter((e) => {
        return this.buttonIds.includes(e);
      });
      return arr[0];
    },
    refresh() {
      this.pageIndex = 1;
      this.getData();
    },
    dblRowHandle: function({ row }) {
      if (this.tableConfig.dblClick) {
        if (this.tableConfig.env == "iframe" && window[this.tableConfig.dblClick]) {
          window[this.tableConfig.dblClick](row);
        }

        if (this.tableConfig.env == "vue" && this.$parent[this.tableConfig.dblClick]) {
          this.$parent[this.tableConfig.dblClick](row);
        }
      }
    },
    chosen() {
      if (this.tableConfig.singleselect) {
        return this.$refs["my_table"].getRadioRecord();
      } else {
        return this.$refs["my_table"].getCheckboxRecords();
      }
    },
    async getData() {
      if (!this.tableConfig.urlConfig.url) {
        return;
      }
      this.loading = true;
      let obj = {
        ...this.tableConfig.urlConfig.param,
      };
      let where = {};
      obj[this.tableConfig.urlConfig.page] = this.pageIndex;
      obj[this.tableConfig.urlConfig.limit] = this.pageSize;
      if (this.tableConfig.queryConfig) {
        for (var i in this.tableConfig.queryConfig) {
          var val = this.tableConfig.queryConfig[i].value;
          if (val == "") {
            val = null;
          }
          obj[i] = val;
        }
      }
      // obj.where = JSON.stringify(where);
      let res = await this.$api.post(this.tableConfig.urlConfig.url, obj);
      let d = res;
      if (res.success) {
        this.rows = d["data"][this.tableConfig.urlConfig.rows];
        this.total = d["data"][this.tableConfig.urlConfig.count];
      } else {
        this.$message.warning(res.msg);
      }
      setTimeout(() => {
        this.loading = false;
      }, 100);
    },
    init() {
      if (this.tableConfig.singleselect) {
        this.radioConfig = {
          trigger: "row",
          labelField: "my_check",
          highlight: true,
        };
      } else {
        this.checkboxConfig = {
          trigger: "row",
          labelField: "my_check",
          highlight: true,
          range: true,
        };
      }
      this.getData();
    },
    refreshColumn() {
      this.$refs["my_table"].refreshColumn();
      // this.refresh();
    },
  },
  computed: {
    buttonIds() {
      return this.$route.meta.buttonIds;
    },
    buttonObj() {
      var obj = {};
      this.$route.meta.button.forEach((e) => {
        obj[e.menuId + ""] = e.name;
      });
      return obj;
    },
  },
  created() {
    document.onkeyup = (e) => {
      if (e.keyCode == 13) {
        this.refresh();
      }
    };
    var q = JSON.parse(JSON.stringify(this.tableConfig.queryConfig));
    for (var i in q) {
      if (q[i].hidden) {
        this.originQueryHidden.push(i);
      }
      this.originQueryValueObj[i] = q[i].value;
    }
    this.init();
  },
  mounted() {},
};
</script>

<style lang="scss">
.weblist_wrap {
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  .top_wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .tools_wrap {
      padding: 5px;
      box-sizing: border-box;
      background: #fff;
      min-height: 38px;
      .my_btn {
        margin: 5px;
      }
      .slot_wrap {
        width: 100%;
      }
      .query_btn_wrap {
        display: flex;
        justify-content: flex-end;
      }
      .query_wrap {
        display: flex;
        flex-wrap: wrap;
        background-color: #f4f5f7;
        border: 1px solid #ccc;
        padding: 5px;
        box-sizing: border-box;
        border-radius: 4px;
        margin: 10px 0 15px;
        position: relative;
        .showMore {
          position: absolute;
          border: 1px solid #ccc;
          width: 80px;
          height: 18px;
          font-size: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          left: calc(50% - 40px);
          // right: -1px;
          bottom: -18px;
          border-top: none;
          background: #f4f5f7;
          border-radius: 0 0 5px 5px;
          cursor: pointer;
          color: #409eff;
          i {
            color: #409eff;
            font-size: 20px;
          }
        }
        .query_item {
          display: flex;
          align-items: center;
          padding: 5px 10px;
          width: 33%;
          .my_inp {
            width: 100%;
          }
          .lab {
            color: #5faeff;
            // font-weight: bold;
            padding-right: 3px;
            flex: 0 0 90px;
            font-size: 14px;
          }
          .con {
            flex: 1;
            display: flex;
            justify-content: space-between;
            .my_btn {
              width: 48%;
              margin-right: 0;
            }
          }
        }
        .w_25 {
          width: 25% !important;
          .query_btn {
            width: 100%;
          }
        }
        .w_33 {
          width: 33% !important;
          .query_btn {
            width: 100%;
          }
        }
        .w_50 {
          width: 50% !important;
          .query_btn {
            width: 50%;
          }
        }
        .w_100 {
          width: 100% !important;
          .query_btn {
            width: 25%;
          }
        }
        .query_btn {
          // flex: 1;
          display: flex;
          .my_btn {
            width: 100%;
          }
        }
      }
    }
    .table_wrap {
      flex: 1;
      overflow: hidden;
      width: 100%;
    }
  }
  .footer_wrap {
    flex: 0 0 48px;
  }
  .head_item {
    text-align: center;
    width: 100%;
  }
  .vxe-header--column.col--ellipsis {
    // height: 60px !important;
  }
  .vxe-header--column .vxe-cell {
    max-height: 80px !important;
    // height: 100%;
  }
  .vxe-body--column .vxe-cell {
    max-height: 80px !important;
    // height: 100%;
    // display: flex;
    // align-items: center;
    // flex-wrap: wrap;
  }
  .vxe-body--column {
    height: 36px !important;
  }
  .vxe-header--column {
    background: linear-gradient(to bottom, #fff 0, #f2f2f2 100%) !important;
    border-right: 1px solid #e8eaec !important;
  }
  .vxe-body--column.col--checkbox {
    background: linear-gradient(to bottom, #fff 0, #f2f2f2 100%) !important;
    border-right: 1px solid #e8eaec !important;
  }
  .vxe-loading {
    background-color: rgba(255, 255, 255, 0.9) !important;
  }
  .vxe-pager.is--loading::after {
    background-color: rgba(0, 0, 0, 0.1) !important;
  }
  .vxe-table--render-default .vxe-cell--checkbox .vxe-checkbox--label,
  .vxe-table--render-default .vxe-cell--radio .vxe-radio--label {
    padding-left: 0 !important;
  }
  .my_table {
    width: 100%;
  }
  .my_table .col-blue {
    color: #409eff !important;
    font-weight: bold;
    background-color: #f5f7fa;
  }
}
</style>
